import { render } from "./FaceAdjustmentModal.vue?vue&type=template&id=698c400e&scoped=true"
import script from "./FaceAdjustmentModal.vue?vue&type=script&lang=js"
export * from "./FaceAdjustmentModal.vue?vue&type=script&lang=js"

import "./FaceAdjustmentModal.vue?vue&type=style&index=0&id=698c400e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698c400e"]])

export default __exports__